// extracted by mini-css-extract-plugin
export default {"tableCategory":"SuppliersTable_tableCategory__UJfEM","tableHeader":"SuppliersTable_tableHeader__BOx2k","table":"SuppliersTable_table__ZS7a3"};